import React from 'react';
import { Shield, Award, Heart } from 'lucide-react';
const logo = '/LogoNew1.png';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-coffee-900 text-cream py-12 pb-24 border-t border-zen-gold/20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
                    {/* Brand */}
                    <div>
                        <div className="flex items-center space-x-3 mb-4">
                            <img src={logo} alt="Healthy Massage Logo" className="h-16 w-16 -my-2 object-contain" />
                            <div>
                                <h3 className="text-xl font-display font-bold text-white">Healthy Massage Home Service</h3>
                                <p className="text-sm text-cream/70">Bengaluru</p>
                            </div>
                        </div>
                        <p className="text-cream/80 text-sm">
                            Professional home service massage therapy with 15+ years of certified expertise.
                            Government registered and diploma certified.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="text-lg font-bold text-white mb-4">Quick Links</h4>
                        <ul className="space-y-2">
                            <li>
                                <button
                                    onClick={() => document.getElementById('hero').scrollIntoView({ behavior: 'smooth' })}
                                    className="text-cream/80 hover:text-zen-gold transition-colors"
                                >
                                    Home
                                </button>
                            </li>
                            <li>
                                <button
                                    onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })}
                                    className="text-cream/80 hover:text-zen-gold transition-colors"
                                >
                                    About
                                </button>
                            </li>
                            <li>
                                <button
                                    onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
                                    className="text-cream/80 hover:text-zen-gold transition-colors"
                                >
                                    Services
                                </button>
                            </li>
                            <li>
                                <button
                                    onClick={() => document.getElementById('credentials').scrollIntoView({ behavior: 'smooth' })}
                                    className="text-cream/80 hover:text-zen-gold transition-colors"
                                >
                                    Credentials
                                </button>
                            </li>
                            <li>
                                <button
                                    onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                                    className="text-cream/80 hover:text-zen-gold transition-colors"
                                >
                                    Contact
                                </button>
                            </li>
                        </ul>
                    </div>

                    {/* Trust Badges */}
                    <div>
                        <h4 className="text-lg font-bold text-white mb-4">Our Credentials</h4>
                        <div className="space-y-3">

                            <div className="flex items-start space-x-3">
                                <Award className="text-zen-gold flex-shrink-0" size={20} />
                                <div>
                                    <p className="font-semibold text-white text-sm">Diploma - Ayurveda & Panchakarma </p>
                                    <p className="text-xs text-cream/70">ICPEM (2007)</p>
                                </div>
                            </div>
                            <div className="flex items-start space-x-3">
                                <Award className="text-zen-gold flex-shrink-0" size={20} />
                                <div>
                                    <p className="font-semibold text-white text-sm">Diploma - Spa & Thai</p>
                                    <p className="text-xs text-cream/70">ICPEM (2010)</p>
                                </div>
                            </div>
                            <div className="flex items-start space-x-3">
                                <Shield className="text-zen-gold flex-shrink-0" size={20} />
                                <div>
                                    <p className="font-semibold text-white text-sm">Govt Registered</p>
                                    <p className="text-xs text-cream/70">Karnataka Labour Dept (2018)</p>
                                </div>
                            </div>
                            <div className="flex items-start space-x-3">
                                <Heart className="text-zen-gold flex-shrink-0" size={20} />
                                <div>
                                    <p className="font-semibold text-white text-sm">15+ Years Experience</p>
                                    <p className="text-xs text-cream/70">Trusted Professional</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="border-t border-cream/20 pt-8 text-center">
                    <p className="text-cream/70 text-sm">
                        © {currentYear} Healthy Massage Home Service Bengaluru. All rights reserved.
                    </p>
                    <p className="text-cream/60 text-xs mt-2">
                        Professional Home Service Massage | Government Registered Therapist
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
